module.exports = __webpack_public_path__ + "static/media/logo.05a3e30f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/logo.svg
// module id = 28
// module chunks = 0